import React from 'react';
import './WelcomeSection.css';

const WelcomeSection = () => {
const accreditationLogos = [
  { src: "/Assets/Asset_1.webp", alt: "Maharashtra State Government" },
  { src: "/Assets/Asset_3.webp", alt: "University of Mumbai" },
  { src: "/Assets/Asset_4.webp", alt: "UGC Autonomous Institute" },
  { src: "/Assets/Asset_7.webp", alt: "AICTE" },
  { src: "/Assets/NAAC_logo.webp", alt: "NAAC A Plus" },
  { src: "/Assets/Asset_6.webp", alt: "NBA" },
  { src: "/Assets/Asset_5.webp", alt: "ISO" }
];

  // --- Inline SVG Icons ---
  const MapPinIcon = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;

  return (
    <div className="tm-wrapper">
      <div className="tm-grid-overlay"></div>

      <div className="tm-hero-container">
        <div className="tm-content-grid">
          
          {/* Left Side: Visual HUD Assets */}
          <div className="tm-visual-stack">
            <div className="tm-main-frame">
              <img src="/Infra/Image.jpg.jpeg" alt="Campus" className="tm-campus-img" />
              
              <div className="tm-frame-footer">
                <div className="tm-active-link">
                  <div className="tm-pulse-line"></div>
                  LINK_ACTIVE // READY
                </div>
                <div className="tm-geo-data">
                  <MapPinIcon /> 19.21N / 72.86E
                </div>
              </div>
            </div>

            <div className="tm-inset-feed tm-anim-float-delay">
              <video 
                autoPlay 
                muted 
                loop 
                playsInline
                className="tm-feed-video"
              >
                <source src="/images/Carasouel/TIMSCDR-head-web-1.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="tm-video-overlay"></div>
            </div>
          </div>

          {/* Right Side: Primary Content */}
          <div className="tm-text-stack">
            <div className="tm-hero-title">
              {/* <span className="tm-flicker-bracket">[</span>  */}
              <span className="tm-flicker-text">WELCOME TO</span> 
              {/* <span className="tm-flicker-bracket">]</span> */}
              <div className="tm-brand-accent">TIMSCDR</div>
            </div>

           <div className="tm-hero-desc">
  Thakur Institute of Management Studies, Career Development & Research (TIMSCDR) was established in 2001 under the aegis of the Thakur Educational Trust of the <span className="tm-highlight-brand">Thakur Education Group</span>, with a clear objective of providing quality technical education aligned with international standards and contemporary global demands.
</div>

            <div className="tm-accreditation-section" aria-label="Accreditations">
              <div className="tm-accreditation-title">Accreditations</div>
              <div className="tm-accreditation-grid">
                {accreditationLogos.map((logo) => (
                  <div className="tm-accreditation-logo" key={logo.src}>
                    <img src={logo.src} alt={logo.alt} loading="lazy" />
                  </div>
                ))}
              </div>
            </div>

            <div className="tm-legacy-section">
              <div className="tm-bg-year">2001</div>
              <div className="tm-legacy-header">
                <div className="tm-mono-xs">CORE_LEGACY_ESTABLISHED</div>
                <div className="tm-dash-divider"></div>
              </div>
              <div className="tm-legacy-body">
                <div className="tm-est-label">EST. 2001</div>
                <div className="tm-sync-box">
                  {/* <div className="tm-sync-bar"><div className="tm-sync-fill"></div></div>
                  <div className="tm-sync-meta">
                    <span><span className="tm-sync-dot"></span>SYNCING_DATA</span>
                    <span>782.4 GB/s</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;